var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnergy = function SvgEnergy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C13.6667 18 15.075 17.4167 16.225 16.25C17.375 15.0833 17.9667 13.6667 18 12V6H12C10.3333 6.03333 8.91668 6.625 7.75001 7.775C6.58335 8.925 6.00001 10.3333 6.00001 12C6.00001 13.6667 6.58335 15.0833 7.75001 16.25C8.91668 17.4167 10.3333 18 12 18ZM10.55 16.55L15.425 12.225L15.15 11.425L11.55 11.075L13.875 7.825L13.475 7.4L8.60001 11.75L8.87501 12.55L12.475 12.9L10.125 16.125L10.55 16.55ZM12 20C11.0667 20 10.1877 19.8543 9.36301 19.563C8.53835 19.2717 7.78401 18.859 7.10001 18.325L5.00001 20.425L3.57501 19L5.67501 16.9C5.14168 16.2167 4.72935 15.4627 4.43801 14.638C4.14668 13.8133 4.00068 12.934 4.00001 12C4.00001 9.76667 4.77501 7.875 6.32501 6.325C7.87501 4.775 9.76668 4 12 4H20V12C20 14.2333 19.225 16.125 17.675 17.675C16.125 19.225 14.2333 20 12 20Z",
    fill: "#050505"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnergy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/energy.0d57da1b.svg";
export { ForwardRef as ReactComponent };